<template>
  <div class="product-card">
    <slot name="product"
    :info="info"
    :marketplaces="marketplaces"
    :quntity="quantity"
    :link="link"
    :isFav="isFav"
    :inBasket="inBasket"
    :addToBasket="addToBasket"
    :addToFavs="addToFavs"
    :moduleBasket="moduleBasket"
    :moduleFavorites="moduleFavorites"
    ></slot>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  name : "CatalogProduct",
  props : [
    "info",
    "marketplaces"
  ],
  data()
  {
    return {
      quantity : 1,
      link     : ""
    };
  },
  computed : {
    ...mapState([
      "moduleBasket", "moduleFavorites"
    ]),
    isFav()
    {
      for(let fav in this.moduleFavorites.favorites)
        if(parseInt(this.moduleFavorites.favorites[fav].ID) === parseInt(this.info.ID))
        {
          return true;
        }
      return false;
    },
    inBasket()
    {
      for(let fav in this.moduleBasket.basket)
        if(parseInt(this.moduleBasket.basket[fav].PRODUCT_ID) === parseInt(this.info.ID))
        {
          return true;
        }
      return false;
    }
  },
  methods  : {
    ...mapActions([
      "ADD_BASKET_ITEM", "ADD_FAVS_ITEM", "DEL_FAVS_ITEM"
    ]),
    addToBasket()
    {
      this.ADD_BASKET_ITEM({
        id       : this.info.ID,
        quantity : this.quantity
      });
    },
    addToFavs()
    {
      if(this.isFav)
      {
        this.DEL_FAVS_ITEM(this.info.ID);
      }
      else
      {
        this.ADD_FAVS_ITEM(this.info);
      }
    }
  },
  created()
  {
    if(this.info.URL)
    {
      this.link = this.info.URL;
    }
    if(this.info.DETAIL_PAGE_URL)
    {
      this.link = this.info.DETAIL_PAGE_URL;
    }
  }
};
</script>